<template>

  <div >
    <div class="form__group">
    <label :for="name" v-if="label">{{ label }}: <span class="required" v-if="required">*</span></label>
    <input type="file" id="uploadCaptureInputFile" :name="name" @change="onFileSelect" :required="required" class="form-control" :class="{'is-danger': fileError || hasError }">
    <span class="help is-danger" v-if="fileError || hasError">{{ errorMessage }}</span>
  </div>
    <modal 
      name="cropImage" 
      :clickToClose="false" 
      :adaptive="true" 
      :scrollable="true" 
      height="auto" 
      width="90%" 
      maxWidth="600"
      @before-open="resetModalHeight"
    >
      <div style="padding: 20px;">
        <h3 style="margin-top: 0; margin-bottom: 15px;">Crop Image</h3>
        <VueCropper v-show="selectedFile" ref="cropper" :viewMode="3" :zoomable="false"  :aspect-ratio="4/3" :src="selectedFile" alt="Source Image" style="width: 100%; max-height: 400px;"></VueCropper>               
        <div style="margin-top: 15px; text-align: center;">
          <button class="btn btn--primary"  @click="cancel()" style="margin-right: 10px;">Cancel</button>
          <button class="btn btn--primary" id="save-race-image" @click="cropImage()">Save</button>          
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'
import VueCropper from 'vue-cropperjs'
const Compress = require('client-compress')
import 'cropperjs/dist/cropper.css'
import service from '@/services/index'
import { mapActions } from 'vuex'

const resource = service.resource('races/upload-image')

export default {
  components: { VueCropper },
  // props: ['image_name'],
   props: {
    label: {
      required: false,
      type: String
    },
    value: {
      required: true
    },
    name: {
      required: true,
      type: String
    },
    errorMessage: {
      required: false,
      type: String
    },
    hasError: {
      required: false
    },
    required: {
      type: Boolean
    }
  },
  data() {
    return {
      input: '',
      mime_type: '',
      cropedImage: '',
      autoCrop: false,
      selectedFile: '',
      image: '',
      dialog: false,
      files: '',
      file_name:'',
      fileError:false
    }
  },
  computed: {

  },
  methods: {
    cropImage() {
      console.log("crop image inside")
      // const userId = this.$route.params.user_id
      this.cropedImage = this.$refs.cropper.getCroppedCanvas().toDataURL()    
      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
          const size = blob.size/1024
          console.log("size---",size)
          if(size > 200){
            this.compressImage(blob) //Compress image if file size is larger than 200kb
            //  this.fileError=true
            //  this.$emit('input', null)
            //  this.showCropWindow = false  
          }else { 
            this.fileError=false
            const formData = new FormData()
            formData.append('file', blob, this.file_name)  
            this.saveImageButton()     
            this.addTaskToQueue('saveRacePhoto')
              resource.save(formData)
                .then(({ body }) => {
                this.$emit('input', body.url)
                this.removeTaskFromQueue('saveRacePhoto')
                this.resetSaveImageButton()
                this.$modal.hide('cropImage')      
              })
          }
      }, this.mime_type)
    },
    onFileSelect(e) {
      const file = e.target.files[0]      
      const size = file.size/1024
      console.log("size---",size)
      if(size <= 200){
        const imgFile = new FormData()
        imgFile.append('file', file)
         this.addTaskToQueue('saveRacePhoto')
          resource.save(imgFile)
            .then(({ body }) => {
            this.$emit('input', body.url)
            this.removeTaskFromQueue('saveRacePhoto')
          })
      }else{
        this.mime_type = file.type
        if (typeof FileReader === 'function') {
          this.dialog = true
          const reader = new FileReader()
          reader.onload = (event) => {
            this.selectedFile = event.target.result
            this.$refs.cropper.replace(this.selectedFile)
          }
          reader.readAsDataURL(file)
          this.$modal.show('cropImage')
        } else {
          alert('Sorry, FileReader API not supported')
        }
      }
    },
    compressImage(blob){
      console.log("Compress Image")
      const options = {
        targetSize: 0.2,
        quality: 0.75,
        maxWidth: 800,
        maxHeight: 600
      }
      const compress = new Compress(options)
      compress.compress([blob]).then((conversions) => {        
        const { photo, info } = conversions[0]           
        const size = photo.data.size/1024
        console.log("Compress image size---",size)
        if(size > 200){
          this.fileError=true
          this.$emit('input', null)
          this.$modal.hide('cropImage')  
        }else {             
          this.fileError=false
          const formData = new FormData()
          formData.append('file', photo.data)
          this.saveImageButton()     
          this.addTaskToQueue('saveRacePhoto')
          resource.save(formData)
            .then(({ body }) => {
            this.$emit('input', body.url)
            this.removeTaskFromQueue('saveRacePhoto')
            this.resetSaveImageButton()
            this.$modal.hide('cropImage')      
          })
        } 
      })
    },
    saveImageButton() {
        const btnsave = document.querySelector('#save-race-image')
        btnsave.innerHTML = 'Saving...'
        btnsave.setAttribute('disabled', true)
      },
    resetSaveImageButton() {
        const btnsave = document.querySelector('#save-race-image')
        btnsave.innerHTML = 'Save'
        btnsave.removeAttribute('disabled', true)
    },
    resetModalHeight() {
      // Fix for vue-js-modal height calculation issue
      this.$nextTick(() => {
        const modal = this.$modal
        if (modal && modal.modal && modal.modal.renderedHeight) {
          modal.modal.renderedHeight = ''
        }
      })
    },
    onClose() {
      this.$modal.hide('cropImage')      
    },
    cancel(){
      document.getElementById("uploadCaptureInputFile").value = ""
      this.$modal.hide('cropImage')   
    },
     ...mapActions({
      addTaskToQueue: 'LoadingQueue/addTaskToQueue',
      removeTaskFromQueue: 'LoadingQueue/removeTaskFromQueue'
    })
  },
}
</script>
<style scoped>
.user {
  width: 140px;
  height: 140px;
  border-radius: 100%;
  border: 3px solid #2e7d32;
  position: relative;
}
.profile-img {
  height: 100%;
  width: 100%;
  border-radius: 50%;
}
.icon {
  position: absolute;
  top: 10px;
  right: 0;
  background: #e2e2e2;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  line-height: 30px;
  vertical-align: middle;
  text-align: center;
  color: #0000ff;
  font-size: 14px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// UploadPhoto.vue?4870cf32